import React from 'react';
import { createRoot } from 'react-dom/client';
import '../assets/colors_and_type.css';
import '../styles.css';
import App from './app.jsx';

createRoot(document.getElementById('root')).render(<App />);
